<div class="dialog main-task-form-layout">
  @if (isMobileView()) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" class="task-header-action" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ (task?.id ? 'Edit task' : 'New task') | translate | titlecase }}</h2>
      <p class="task-header-action disabled" disabled="true" translate>Save</p>
    </header>
  }
  @if (!isMobileView()) {
    <header class="dialog__header">
      <h2 class="dialog__header__title">{{ (task?.id ? 'Edit task' : 'New task') | translate | titlecase }}</h2>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon (click)="close()" [ngStyle]="{ cursor: 'pointer' }" iconName="close"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="mt-30 margin-for-web">
      <!--  Title  -->
      <div class="input-group --required">
        <label for="title" translate>Title</label>
        <input [placeholder]="'Enter Title' | translate" formControlName="title" id="title" name="title" type="text" />
        <app-form-error [control]="form.get('title')" [name]="'Title' | translate"></app-form-error>
      </div>
      <!-- Image -->
      <div class="card mt-24">
        <div>
          <app-image-selector
            (imageSelected)="onImageSelection($event)"
            [aspectRatio]="4 / 3"
            [entityId]="taskId"
            [fullWidthPreview]="true"
            [imageCropper]="true"
            [isUpdateMode]="isUpdateMode"
            [sectionType]="SectionType.TASK"
            formControlName="image"
          ></app-image-selector>
        </div>
      </div>
      <!-- Date -->
      <div class="input-group full-width-input --required">
        <label for="date" translate>Date</label>
        <app-date-picker-input [pastDatesSelection]="false" class="full-width-input" formControlName="date" id="date" name="date"></app-date-picker-input>
        <app-form-error [control]="form.get('date')" [name]="'Date' | translate"></app-form-error>
      </div>
      <!-- Description -->
      <div class="input-group --required">
        <label for="description" translate>Description</label>
        <textarea formControlName="description" id="description" name="description" rows="3"></textarea>
        <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
      </div>
      <!-- Tag -->
      <div class="input-group">
        <label for="tags" translate>Tags</label>
        <ng-select
          [addTag]="addTagFn"
          [items]="tags"
          [multiple]="true"
          [notFoundText]="'No tags available' | translate"
          [placeholder]="'Enter to search' | translate"
          [selectOnTab]="true"
          bindLabel="tagName"
          bindValue="tagName"
          class="custom"
          formControlName="tags"
          id="tags"
          searchable="true"
        ></ng-select>
      </div>

      <!--  Task Type  -->
      <div class="input-group --required">
        <label translate>Task Type</label>
        <app-dropdown [options]="taskTypes" bindValue="value" displayName="key" formControlName="type" [disabled]="shouldLockGroupDropdown"></app-dropdown>
        <app-form-error [control]="form.get('type')" [name]="'Task Type' | translate"></app-form-error>
      </div>

      <!--  Dynamic dropdown rendering For Individual -->
      @if (form.get('type').value === TasksType.Individual) {
        <div class="input-group --required">
          <label for="collaborators" translate>Members</label>
          <ng-select
            [dropdownPosition]="'top'"
            [items]="users"
            [multiple]="true"
            [placeholder]="'Select' | translate"
            [selectOnTab]="true"
            bindLabel="fullName"
            bindValue="id"
            class="custom"
            formControlName="collaborators"
            id="collaborators"
          ></ng-select>
          <app-form-error [control]="form.get('collaborators')" [name]="'Members' | translate"></app-form-error>
        </div>
      }

      <!--  Dynamic dropdown rendering For Groups  -->
      @if (form.get('type').value === TasksType.Group) {
        <div class="input-group --required">
          <label for="groupId">Group</label>
          <app-dropdown [dropdownPosition]="'top'" [options]="groups" bindValue="id" displayName="name" formControlName="groupId" id="groupId" [disabled]="shouldLockGroupDropdown"></app-dropdown>
          <app-form-error [control]="form.get('groupId')" [name]="'Group' | translate"></app-form-error>
        </div>
      }

      @if (subtaskCreatePermission) {
        <!--  Add SubTask  -->
        <div class="flex-row-between-center mt-24">
          <p class="sub-tasks" translate>Subtasks</p>
          <div (click)="openSubtaskBottomSheet()">
            <app-icon [size]="isMobileView() ? '12px' : '16px'" iconName="add"></app-icon>
            <span class="add-subtasks ml-6" translate>Add Sub-task</span>
          </div>
        </div>
        <!--  SubTask List  -->
        <div class="sub-tasks-wrapper">
          @for (subTask of subTaskFormArray.value; track subTask) {
            <ul class="mt-16">
              <li>
                <div class="flex-row-between-center mb-8">
                  <div class="flex-row-start-center">
                    <p class="sub-tasks">{{ subTask.title }}</p>
                    <p class="sub-task-date ml-9">{{ subTask.date | date: 'MMM d, YYYY' }}</p>
                  </div>
                  <div>
                    <app-icon (click)="updateSubTask(subTask)" [ngStyle]="{ cursor: 'pointer' }" [tippy]="'Edit' | translate" iconName="pencil" size="18px"></app-icon>
                    <app-icon (click)="confirmSubtaskDelete(subTask)" [ngStyle]="{ cursor: 'pointer', marginLeft: '6px' }" [tippy]="'Delete' | translate" iconName="trash" size="18px"></app-icon>
                  </div>
                </div>
              </li>
            </ul>
          }
        </div>
      }
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView()) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [idleText]="task?.id ? 'Update' : ('Create' | translate)" cssClass="button-primary"></app-button>
        </div>
      }

      @if (isMobileView()) {
        <div class="w-100 mb-34">
          <app-button (clickEvent)="save($event)" [idleText]="(task?.id ? 'Update' : 'Create') | translate" cssClass="button-primary button-full"></app-button>
        </div>
      }
    </div>
  </footer>
</div>
